import Logo from "assets/auth/Logo.png";
import { ErrorMessage, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SyncLoader } from "react-spinners";
import { apiReq } from "services/Requests";
import { API_ROUTES } from "utils/apiRoutes.constant";
import { Button } from "../../reusable/button/Button";
import {
  ForgetPasswordWrapper,
  LoginMessageWrapper,
} from "../signin/Signin.style";
import {
  FieldWrapper,
  FormLogo,
  FormSec,
  FormWrapper,
  StyledInput,
} from "../signup/Signup.style";
import { updateUserPassword } from "utils/firebase";
import { toast } from "react-toastify";
import { auth } from "FirebaseSetup";

const StaffResetPass = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [showPass, setShowPass] = useState(false);
  const [spinner] = useState(false); // Add spinner state

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetPassword = async (values) => {
    try {
      if (!formData.password || !formData.confirmPassword) {
        alert("Password fields cannot be empty");
        return;
      }
      // const resetEmail = localStorage.getItem("resetEmail");
      // console.log(resetEmail, "resetEmail_staff", formData, "formData_staff");

      // const { success, message, error } = await updateUserPassword({
      //   oldPassword: formData.password,
      //   newPassword: formData.confirmPassword,
      //   confirmPassword: formData.confirmPassword,
      // });

      // if (success) {
      //   toast.success(message);
      //   navigate("/staff-signin");
      // } else {
      //   toast.error(error);
      // }

      // Get email from resetEmail or fallback to userData
      let resetEmail = localStorage.getItem("resetEmail");
      
      // Fallback: Try to get email from userData if resetEmail is not available
      if (!resetEmail) {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        resetEmail = userData?.user?.email;
      }
      
      if (!resetEmail) {
        toast.error("Email not found. Please request a new password reset.");
        return;
      }
      
      // Prepare API request body
      const apiRequestBody = {
        email: resetEmail,
        password: formData.password,
        role: "Staff",
      };
      
      const response = await apiReq(API_ROUTES.updateUserPassword, "POST", apiRequestBody);
      
      if (response.status === 200) {
        toast.success("Password updated successfully");
        
        // Check if user is signed in
        const isSignedIn = auth.currentUser !== null;
        const hasAuthToken = localStorage.getItem("auth");
        
        // If user is not signed in, redirect to sign in page
        if (!isSignedIn || !hasAuthToken) {
          setTimeout(() => {
            navigate("/staff-signin");
          }, 1500);
        }
        // Otherwise, keep user logged in (no redirect)
      } else {
        toast.error("Failed to update password");
      }
    } catch (error) {
      console.error("Error during password reset:", error.message);
    }
  };

  return (
    <Formik
      initialValues={{
        password: "",
        confirmPassword: "",
        role: "Staff",
      }}
      onSubmit={handleResetPassword}
    >
      <FormWrapper>
        <FormSec gridGap="30px">
          <FormLogo>
            <img src={Logo} alt="Logo" />
          </FormLogo>
          <LoginMessageWrapper>
            <h5>Change Password</h5>
            <p>Enter new Password</p>
          </LoginMessageWrapper>

          <ForgetPasswordWrapper>
            <FieldWrapper>
              <p>Password</p>
              <StyledInput
                type={showPass ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
              />
              <h5 onClick={() => setShowPass(!showPass)}>
                {showPass ? "HIDE" : "SHOW"}
              </h5>
              <ErrorMessage name="username" component="div" />
            </FieldWrapper>
            <FieldWrapper>
              <p>Confirm Password</p>
              <StyledInput
                type={showPass ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
              <h5 onClick={() => setShowPass(!showPass)}>
                {showPass ? "HIDE" : "SHOW"}
              </h5>
              <ErrorMessage name="username" component="div" />
            </FieldWrapper>
          </ForgetPasswordWrapper>
          <Button
            text={
              spinner ? (
                <SyncLoader color={"#FFFFFF"} size={8} />
              ) : (
                "Reset Password"
              )
            } // Change button text based on loading state
            width="100%"
            fontSize="18px"
            disabled={spinner}
            onClick={() => {
              handleResetPassword();
            }}
          />
          {/* <AlreadyAcc>
            <p>Don't have a account? </p>{" "}
            <h5 onClick={() => navigate("/")}> Login</h5>
          </AlreadyAcc> */}
        </FormSec>
      </FormWrapper>
    </Formik>
  );
};

export default StaffResetPass;
